/***************************************************************************/
"use server";
/***************************************************************************/

import { TUserLoginData } from "@/app/api/auth/login/interfaces.universal";
import crud from "@/server/api/crud";
import getTranslation from "@/server/i18n/use-translation";
import { TResponseBody } from "@/universal/api/types";
import { createUserSession } from "../../_actions/create-user-session";
import { TOTPVerificationResult } from "../types";

const verifyOTPAction = async (
  otp: string,
): Promise<TOTPVerificationResult> => {
  const { t: tAuth } = await getTranslation("auth");
  try {
    const otpVerifyResult = await crud(
      "Self",
      "auth/verify-otp",
      {},
      {
        method: "POST",
        body: JSON.stringify({ otp }),
      },
    );
    const otpResultJSON =
      (await otpVerifyResult.json()) as TResponseBody<TUserLoginData>;
    if (otpVerifyResult.status === 200 && otpResultJSON?.data) {
      await createUserSession(otpResultJSON?.data);

      return {
        formErrors: [],
      };
    } else if (
      otpVerifyResult.status === 400 ||
      otpVerifyResult.status === 401
    ) {
      return {
        formErrors: [tAuth("otp.error.incorrectOtp")],
      };
    } else {
      return {
        formErrors: [tAuth("login.someErrorOccurred")],
      };
    }
  } catch (error) {
    console.error(error);

    return {
      formErrors: [tAuth("login.someErrorOccurred")],
    };
  }
};

const resendOTPAction = async (): Promise<{
  status?: boolean;
  formErrors?: string[];
  message?: string;
}> => {
  const { t: tAuth } = await getTranslation("auth");
  try {
    const resendOTPResult = await crud(
      "Self",
      "auth/resend-otp",
      {},
      {
        method: "POST",
      },
    );

    if (resendOTPResult.status === 200) {
      return {
        status: true,
        message: tAuth("otp.resend.successMessage"),
      };
    } else if (resendOTPResult.status === 400) {
      return {
        formErrors: [tAuth("otp.resend.someErrorOccurred")],
      };
    } else {
      return {
        formErrors: [tAuth("otp.resend.someErrorOccurred")],
      };
    }
  } catch (error) {
    console.error(error);
    return {
      formErrors: [tAuth("otp.resend.someErrorOccurred")],
    };
  }
};

export { resendOTPAction, verifyOTPAction };
